import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Switch, Typography, Box, Tooltip, Grid, Card } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

/**
 * ModuleManagement component for enabling/disabling modules for a customer
 * @param {Array} modules - Array of module objects
 * @param {Function} handleModuleToggle - Callback when a module is toggled
 */
export function ModuleManagement({ modules, handleModuleToggle }) {
  return (
    <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Module Management
                </MDTypography>
              </MDBox>

              <Box sx={{ p: 4 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Enable or disable feature modules for this customer. The Setup module is mandatory and cannot be disabled.
                </Typography>
                <Grid container spacing={2}>
                  {modules?.map((mod) => (
                    <Grid item xs={12} sm={6} key={mod.id}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ bgcolor: "#f9f9fb", p: 2, borderRadius: 2 }}
                      >
                        <Box display="flex" alignItems="center" gap={1}>
                          <Typography fontWeight="bold">{mod.name}</Typography>
                          <Tooltip title={mod.description} placement="top">
                            <Typography color="text.secondary" sx={{ cursor: "pointer" }}>
                              ⓘ
                            </Typography>
                          </Tooltip>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                          {mod.isRequired && (
                            <LockIcon fontSize="small" color="disabled" />
                          )}
                          <Switch
                            checked={mod.enabled}
                            onChange={() => handleModuleToggle(mod.id)}
                            disabled={mod.isRequired}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>

            </Card>
          </Grid>
        </Grid>
      </MDBox>
  );
}

ModuleManagement.propTypes = {
  modules: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      enabled: PropTypes.bool.isRequired,
      isRequired: PropTypes.bool
    })
  ).isRequired,
  handleModuleToggle: PropTypes.func.isRequired
};


export default ModuleManagement;